import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Footer.module.sass";
import { aggressiveLogout } from "../../utils/authHelpers";
 
const Footer = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    try {
      const email = typeof window !== 'undefined' ? window.localStorage.getItem('postaway_email') || '' : '';
      setLoggedIn(Boolean(email));
    } catch (_) {}

    const handleStorage = () => {
      try {
        const emailNow = typeof window !== 'undefined' ? window.localStorage.getItem('postaway_email') || '' : '';
        setLoggedIn(Boolean(emailNow));
      } catch (_) {}
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('storage', handleStorage);
      return () => window.removeEventListener('storage', handleStorage);
    }
  }, []);

  return (
    <div className={styles.footer}>
      <div className={cn("container", styles.container)}>
        <div className={styles.bottom}>
          <div className={styles.copyright}>
            Copyright © 2025 Postaway | All rights reserved
            {loggedIn && (
              <>
                {" | "}
                <button
                  type="button"
                  onClick={() => {
                    aggressiveLogout(null);
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    color: '#0f084b',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    font: 'inherit'
                  }}
                  aria-label="Logout"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
